
export default class ApiResponse {
    constructor(rawResponse = null, data = null) {
        this.rawResponse = rawResponse ? rawResponse.clone() : null;
        this.status = rawResponse ? rawResponse.status : null;
        this.statusText = rawResponse ? rawResponse.statusText : null;

        this.data = data;
        this.success = rawResponse ? rawResponse.ok : false;
        this.message = null;
        this.changed = true;
        this.networkError = null;

        this.setContentType(rawResponse);
    }

    setContentType(rawResponse) {
        this.contentTypeFull = rawResponse ? rawResponse.headers.get("content-type").trim().toLowerCase() : '';

        const contentTypeParts = this.contentTypeFull.split('/');

        this.contentTypeGroup = contentTypeParts[0];
        this.contentType = contentTypeParts.length > 1 ? contentTypeParts[1] : contentTypeParts[0];
    }

    setData(rawData) {
        if(this.contentType == 'json') {
            let rawJsonData = rawData;
        
            if('success' in rawJsonData) {
                this.success = true;
                this.data = 'data' in rawJsonData ? rawJsonData.data : null;
                this.changed = !('changed' in rawJsonData) || rawJsonData.changed;
            } else {
                this.success = false;
                
                if('message' in rawJsonData) {
                    this.message = rawJsonData.message;
                }
                if('errors' in rawJsonData) {
                    this.data = rawJsonData.errors;
                }
            }
        } else {
            this.data = rawData;
        }
    }

    setNetworkError(error) {
        this.success = false;
        this.networkError = error;

        if(!this.message && 'message' in error) {
            this.message = error.message;
        }
    }

    valueOf() {
        return this.data === null && this.message ? this.message : this.data;
    }
}